import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '麻将在线玩',
    url: 'https://www.majiang-online.com/',
    description: '麻将在线玩免费网页版，无需下载即玩。支持国标麻将、四川麻将、广东麻将等多种玩法，免费在线麻将游戏平台。',
    inLanguage: 'zh-CN',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '麻将在线玩',
    url: 'https://www.majiang-online.com/',
    description: '专业的免费在线麻将游戏平台，提供多种麻将玩法，无需下载安装即可畅玩。',
    sameAs: ['https://weibo.com/', 'https://weixin.qq.com/'],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '麻将在线玩需要下载安装吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '完全不需要！麻将在线玩是纯网页版麻将游戏，打开浏览器即可直接玩，无需下载任何软件或插件。',
        },
      },
      {
        '@type': 'Question',
        name: '麻将在线玩完全免费吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，麻将在线玩平台上的所有玩法均完全免费，无隐藏收费，无需充值。',
        },
      },
      {
        '@type': 'Question',
        name: '支持哪些麻将玩法？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '目前平台支持国标麻将、四川麻将、广东麻将、血流成河、长沙麻将、东北麻将等十余种主流玩法。',
        },
      },
      {
        '@type': 'Question',
        name: '可以和朋友在线联机对战吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '当然可以！麻将在线玩支持创建私人房间，邀请好友加入对战。同时也支持随机匹配。',
        },
      },
    ],
  },
];

export default function Home() {
  return (
    <>
      <SEOHead
        title="麻将在线玩免费网页版，无需下载即玩 | 免费在线麻将游戏平台"
        description="想体验麻将在线玩免费网页版？无需下载安装，打开浏览器即可畅玩经典麻将游戏。支持单机对战、多人联机，涵盖国标麻将、四川麻将等多种玩法，随时随地免费开局，是麻将爱好者的首选在线平台。"
        keywords="麻将在线玩免费网页版,免费麻将网页游戏,在线麻将单机版,麻将无需下载直接玩,四川麻将在线免费,国标麻将网页版,多人麻将在线对战"
        canonicalUrl="https://www.majiang-online.com/"
        schemaData={homeSchema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <ArticleSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}